import { Routes } from '@angular/router';
import { authGuard } from './shared/guards/auth.guard';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.routes').then((m) => m.AUTH_ROUTES),
  },
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./shared/admin-shell.component').then((m) => m.AdminShellComponent),
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () =>
          import('./dashboard/dashboard.component').then((m) => m.DashboardComponent),
      },
      {
        path: 'orders/:orderId',
        loadComponent: () =>
          import('./orders/order-detail.component').then((m) => m.OrderDetailComponent),
      },
      {
        path: 'orders',
        loadComponent: () => import('./orders/orders.component').then((m) => m.OrdersComponent),
      },
      {
        path: 'shops/new',
        loadComponent: () =>
          import('./shops/shop-detail.component').then((m) => m.ShopDetailComponent),
      },
      {
        path: 'shops/:shopId',
        loadComponent: () =>
          import('./shops/shop-detail.component').then((m) => m.ShopDetailComponent),
      },
      {
        path: 'shops',
        loadComponent: () => import('./shops/shops.component').then((m) => m.ShopsComponent),
      },
      {
        path: 'products/:productId',
        loadComponent: () =>
          import('./products/product-detail.component').then((m) => m.ProductDetailComponent),
      },
      {
        path: 'products',
        loadComponent: () =>
          import('./products/products.component').then((m) => m.ProductsComponent),
      },
      {
        path: 'gabarits',
        loadComponent: () =>
          import('./print-templates/print-templates.component').then(
            (m) => m.PrintTemplatesComponent,
          ),
      },
      {
        path: 'scripts/:scriptId',
        loadComponent: () =>
          import('./scripts/script-detail.component').then((m) => m.ScriptDetailComponent),
      },
      {
        path: 'scripts',
        loadComponent: () => import('./scripts/scripts.component').then((m) => m.ScriptsComponent),
      },
      {
        path: 'transport-prices',
        loadComponent: () =>
          import('./transport-prices/transport-prices.component').then(
            (m) => m.TransportPricesComponent,
          ),
      },
      {
        path: 'transport-calculator',
        loadComponent: () =>
          import('./transport-calculator/transport-calculator.component').then(
            (m) => m.TransportCalculatorComponent,
          ),
      },
      {
        path: 'transport',
        loadComponent: () =>
          import('./transport/transport.component').then((m) => m.TransportComponent),
      },
      {
        path: 'shipping',
        loadComponent: () =>
          import('./shipping/shipping.component').then((m) => m.ShippingComponent),
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
